import { IconButton, Tooltip } from '@chakra-ui/react';
import { iconStyling } from './agGridStyles';

const TableIconButton = ({ icon, onClick, tooltip }) => {
    return (
        <Tooltip label={tooltip}>
            <IconButton
                sx={iconStyling}
                variant="ghost"
                isRound={true}
                size="sm"
                onClick={onClick}>
                {icon}
            </IconButton>
        </Tooltip>
    );
};

export default TableIconButton;
